import { publicKey } from './auth';
import { ENActionType } from './types/en-action-type';
import { ENPublicDataService } from './types/en-public-data-service';

/**
 * Get the number of action takers so far for a given action.
 */
export const getActionTakersCount = async (params: {
  actionType: ENActionType;
  campaignId: number;
}) => {
  const { actionType, campaignId } = params;
  let service: ENPublicDataService;

  switch (actionType) {
    case 'datacapture':
    default:
      service = 'EaDataCapture';
      break;

    case 'emailtotarget':
      service = 'EaEmailAOTarget';
      break;
  }

  try {
    const url = `/ea-dataservice/data.service?service=${service}&token=${publicKey}&campaignId=${campaignId}&contentType=json&resultType=summary`;

    const response = await fetch(url);

    if (!response.ok) throw new Error(`HTTP error: ${response.status} ${response.statusText}`);

    const data = await response.json();

    if (!data || typeof data !== 'object') throw new Error('Invalid response data');

    // Check if there is any data
    if (!data.rows || !Array.isArray(data.rows) || data.rows.length === 0) return;
    if (
      !data.rows[0].columns ||
      !Array.isArray(data.rows[0].columns) ||
      data.rows[0].columns.length === 0
    )
      return;

    switch (service) {
      case 'EaDataCapture': {
        const participationsData = data.rows[0].columns.find(
          (column: Record<string, string>) => column.name === 'participations',
        );

        if (participationsData && participationsData.value)
          return parseInt(participationsData.value, 10);

        break;
      }

      case 'EaEmailAOTarget': {
        const emailsSentData = data.rows[0].columns.find(
          (column: Record<string, string>) => column.name === 'emailsSent',
        );

        if (emailsSentData && emailsSentData.value) return parseInt(emailsSentData.value, 10);

        break;
      }
    }
  } catch (error) {
    console.error('Error fetching action takers count:', error);
  }
};
